export default __webpack_public_path__ + "static/elian-bitmoji-c7d68c4ddafb64e4bb7605ffadf126c9.png";